import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Field } from 'app/shared/components/field/model/field.interface';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FormDefinition } from 'app/shared/models/class/forms/form-definition';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { ClubService } from 'app/shared/services/club/club.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FormService } from 'app/shared/services/forms/form.service';
import { UiService } from 'app/shared/services/ui/ui.service';

@Component({
  selector: 'app-open-dialog-admin-form',
  templateUrl: './open-dialog-admin-form.component.html',
  styleUrls: ['./open-dialog-admin-form.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class OpenDialogAdminFormComponent implements OnInit {

  form!: UntypedFormGroup;
  isLoading: boolean = false;
  offers: FullOffer[] = [];
  fields: Field[] = [];
  clubs: ClubDetails[] = [];
  clubsSelected: ClubDetails[] = [];
  articleIds: number[] = [];
  actorIds: number[] = [];
  canCustomFieldsSubmit: boolean = false;

  @Input() formDefinition!: FormDefinition;
  @Output() getOpenForm: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly uiService: UiService,
    private readonly faIconService: FaiconService,
    private readonly formService: FormService,
    private readonly clubService: ClubService

  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getClubs();
    this.updateCustomFieldsSubmit();
  }

  cancel(): void {
    this.getOpenForm.emit({bool: false});
  }

  back(): void {
    this.getOpenForm.emit({bool: false});
  }

  onFieldsChange(fields: Field[]): void {
    this.fields = fields;
    this.updateCustomFieldsSubmit();
  }

  onSelectClub(event: any): void {
    this.clubsSelected = event.value;
    this.actorIds = this.clubsSelected.map(club => club.clubKey!);
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  save(): void {
    this.isLoading = true;
    const formValue = this.form.value;
    let message = `Le formulaire a été ajouté avec succès.`;

    let formDefinitionToSend: FormDefinition = {
      enabled: false,
      name: formValue.name,
      description: formValue.description,
      actors: this.actorIds,
      fields: this.fields
    }

    if (this.formDefinition) {
      formDefinitionToSend.key = this.formDefinition.key;
      formDefinitionToSend.enabled = this.formDefinition.enabled;
      this.formService.putFormDefinition(formDefinitionToSend).subscribe({
        next: (data: number) => {
          this.isLoading = false;
          this.uiService.showSnackbar('Le formulaire a été mis à jour avec succès.');
          this.getOpenForm.emit({ bool: false, key: data });
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error updating form definition: ', err);
        }
      });
    } else {
      this.formService.postFormDefinition(formDefinitionToSend).subscribe({
        next: (data: number) => {
          this.isLoading = false;
          this.uiService.showSnackbar(message);
          this.getOpenForm.emit({ bool: false, key: data });
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error saving form definition: ', err);
        }
      });
    }
  }

  // private checkIfArrayEqual(arr1: number[], arr2: number[]): boolean {
  //   return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
  // }

  private getClubs(): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.clubs = clubs;
        this.clubs.sort((a: any, b: any) => a.clubCode.localeCompare(b.clubCode));
        if (this.formDefinition) {
          if (this.formDefinition.actors && this.formDefinition.actors.length > 0) {
            this.clubs.forEach(club => {
              if (this.formDefinition.actors!.includes(club.clubKey!)) {
                this.clubsSelected.push(club);
              }
            });
            this.actorIds = this.clubsSelected.map(club => club.clubKey!);
          }
        }
      }
    });
  }

  private initForm(): void {
    let name = '';
    let description = '';

    if (this.formDefinition) {
      this.fields = this.formDefinition.fields || [];
      name = this.formDefinition.name;
      description = this.formDefinition.description;
    }

    this.form = this.formBuilder.group({
      name: [name, Validators.required],
      description: [description],
      club: [this.clubsSelected]
    });

    this.updateCustomFieldsSubmit();
  }

  private updateCustomFieldsSubmit(): void {
    this.canCustomFieldsSubmit = this.fields.every(field =>
      field.label.trim() && field.options.every(option => option.label.trim())
    );
  }

}
